import { render, staticRenderFns } from "./SelectRejectReasonFoodClaim.vue?vue&type=template&id=033cfc5a&"
import script from "./SelectRejectReasonFoodClaim.vue?vue&type=script&lang=js&"
export * from "./SelectRejectReasonFoodClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports